/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import ArrowleftIcon from '@atlaskit/icon/glyph/chevron-left-large';
import ArrowrightIcon from '@atlaskit/icon/glyph/chevron-right-large';
import { N70 } from '@atlaskit/theme/colors';
import { arrowLeftStyle, arrowRightStyle, headingStyle, monthAndYearStyle } from '../styles/heading';
var Heading = /*#__PURE__*/memo(function Heading(_ref) {
  var monthLongTitle = _ref.monthLongTitle,
      year = _ref.year,
      handleClickPrev = _ref.handleClickPrev,
      handleClickNext = _ref.handleClickNext,
      testId = _ref.testId;
  return jsx("div", {
    css: headingStyle,
    "aria-hidden": "true"
  }, jsx("div", {
    css: arrowLeftStyle
  }, jsx(Button, {
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickPrev,
    testId: testId && "".concat(testId, "--previous-month"),
    iconBefore: jsx(ArrowleftIcon, {
      label: "Last month",
      size: "medium",
      primaryColor: N70
    })
  })), jsx("div", {
    css: monthAndYearStyle,
    "data-testid": testId && "".concat(testId, "--current-month-year")
  }, "".concat(monthLongTitle, " ").concat(year)), jsx("div", {
    css: arrowRightStyle
  }, jsx(Button, {
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickNext,
    testId: testId && "".concat(testId, "--next-month"),
    iconBefore: jsx(ArrowrightIcon, {
      label: "Next month",
      size: "medium",
      primaryColor: N70
    })
  })));
});
Heading.displayName = 'Heading';
export default Heading;